export const reviews: Array<[string, string, string, string]> = [
  [
    'RP',
    'Richard P.',
    'Geology Educator — Bristol, United Kingdom',
    'My students finally understand the difference between igneous, sedimentary, and metamorphic rocks. I used to waste hours searching for the right way to explain how rocks form and transform. Now I enter the classroom fully prepared.',
  ],
  [
    'JW',
    'Jennifer W.',
    'Earth Science Instructor — Dublin, Ireland',
    'I never arrive unprepared anymore. I know exactly how to explain plate tectonics or how to identify minerals and crystals. This resource does the heavy lifting for me.',
  ],
  [
    'NC',
    'Nora C.',
    'Environmental Science Teacher — Munich, Germany',
    'The lesson planning saves me countless hours. The integrated geology projects are organized step-by-step. I never improvise in front of my students anymore.',
  ],
];

export const moreResults: Array<[string, string, string, string]> = [
  [
    'RP',
    'Richard P.',
    'Geology Educator | Bristol, United Kingdom',
    "The material on plate tectonics and mineral identification completely changed how my students understand Earth's structure. They finally grasp how mountains form and earthquakes happen. It's the clearest resource I've found. I use it from day one and it captures their attention immediately.",
  ],
  [
    'JW',
    'Jennifer W.',
    'Earth Science Instructor | Dublin, Ireland',
    'The 150 activities alone are worth the price. I never improvise a lesson anymore. I finish every quarter knowing everything is prepared and ready.',
  ],
  [
    'TM',
    'Thomas M.',
    'Environmental Science Teacher | Berlin, Germany',
    "The 100 real-world case studies transformed how my students see geological hazards. Now they analyze authentic earthquake, volcano, and landslide events and understand why geological knowledge matters. I haven't found this quality in any other resource.",
  ],
  [
    'EH',
    'Elizabeth H.',
    'University Lecturer | Oxford, United Kingdom',
    'The 500-concept guide gave me back my class time. I used to spend twenty minutes explaining how minerals crystallize. Now I show the guide and students instantly understand crystal structures and mineral properties.',
  ],
  [
    'MS',
    'Martin S.',
    'Geology Instructor | Copenhagen, Denmark',
    "The 50 integrated projects were eye-opening. My students finally understand why all this matters. They're identifying rocks in their communities, studying local geological structures, and analyzing natural resources. This completely transformed how they see geology.",
  ],
];
